var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#5E6073"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4752 15.2416C16.4752 14.4088 15.7738 13.7329 14.9095 13.7329C14.0417 13.7329 13.3418 14.4088 13.3418 15.2416C13.3418 16.0749 14.0417 16.7508 14.9095 16.7508C15.7738 16.7508 16.4752 16.0749 16.4752 15.2416ZM16.2611 26.267H13.5563V17.895H16.2611V26.267ZM20.6899 17.8574H18.041V26.2658H20.8012V22.1071C20.8012 21.0098 21.0206 19.9473 22.4589 19.9473C23.877 19.9473 23.8946 21.2017 23.8946 22.1766V26.2658H26.6579V21.6544C26.6579 19.3898 26.1408 17.6489 23.3424 17.6489C21.9983 17.6489 21.0967 18.3459 20.7282 19.0071H20.6899V17.8574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bf5b815352b3f1be30291b95d17c88e2.svg";
export { ForwardRef as ReactComponent };